import { render, staticRenderFns } from "./AlumnosPorProfeListaItem.vue?vue&type=template&id=33f988ce&"
import script from "./AlumnosPorProfeListaItem.vue?vue&type=script&lang=js&"
export * from "./AlumnosPorProfeListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports